var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFanaticism(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.7 41.16l-47.03 1.31 29.3 36.85L116 69.13zm300.6 0L396 69.14l28 10.2 29.3-36.86zm-278.4 8.18L139 79.87l-30.5 11.14L370.7 213.1l19.4-41.6zm256.2 0l-106.7 49.7 54.4 25.36 71.7-33.38L373 79.88zM180.2 144.3l-58.3 27.2 19.4 41.6 93.3-43.4zm241.1 2.8l-49.2 105.5 13 14.9 55.9-120zm-330.63.1l-19.6.4 55.83 119.8 12.9-14.8zm349.43 44.7l-30.6 65.6-34 84.7-55.8 33.3c-3.1 7.3-6.8 14-11.2 20C295.7 413.2 277 425 256 425s-39.7-11.8-52.5-29.5c-4.4-6.1-8.2-12.8-11.3-20.2l-55.1-33.2-27.9-70-37.13-79.7-29.5 19.4 45.5 151.8 81.23 97.1V487h174v-26.2l80.6-97.1 45.6-151.9zM256 249c-14.3 0-27.7 7.9-38 22.1-10.3 14.1-17 34.4-17 56.9s6.7 42.8 17 56.9c10.3 14.2 23.7 22.1 38 22.1s27.7-7.9 38-22.1c10.3-14.1 17-34.4 17-56.9s-6.7-42.8-17-56.9c-10.3-14.2-23.7-22.1-38-22.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanaticism);
export default __webpack_public_path__ + "static/media/fanaticism.07ef901b024a78e9ecbed53b3272560b.svg";
export { ForwardRef as ReactComponent };